export default "__VITE_ASSET__CetPLxzg__"